export const DOCTOR_PHOTO =
  "https://customer-assets-cm19k8pv.emergentagent.net/job_a414808f-4510-4edf-881e-2e91ec17c64e/artifacts/0ltp5d2z_d6aaf412-9778-422c-ab9d-e8e290c6cae0.jpeg";
export const CLINIC_PHOTO =
  "https://images.unsplash.com/photo-1606146350382-64153930ba46?crop=entropy&cs=srgb&fm=jpg&q=80&w=1400";

export const WHATSAPP_NUMBER = "393935189869";
export const WHATSAPP_DISPLAY = "+39 393 518 9869";
export const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
  "Buongiorno Dott. Mauro, vorrei informazioni sulla cura della parodontite con il laser."
)}`;
export const EMAIL = "drnicolamauro@centrodiparodontologia.com";
export const INSTAGRAM_URL = "https://www.instagram.com/igienistadentalenicola";
export const CENTER = "Centro Dentistico Galliera";
export const BOOK_PERIO_PATH = "/prenota-visita-parodontale";
export const FINANCING_PATH = "/dilaziona-preventivo";
export const DIRETTORE = "Marco Quarantini";
export const PIVA = "03620341200";
export const ADDRESS = { street: "Via della Pace 41", cap: "40015", city: "Galliera", prov: "BO" };
export const HOURS = [
  ["Lunedì", "Chiuso"], ["Martedì", "9:00 – 18:00"], ["Mercoledì", "9:00 – 18:00"], ["Giovedì", "9:00 – 18:00"],
  ["Venerdì", "9:00 – 18:00"], ["Sabato", "Chiuso"], ["Domenica", "Chiuso"],
];

export const NAV_LINKS = [
  { id: "parodontite", label: "Parodontite" },
  { id: "laser", label: "Il laser" },
  { id: "protocollo", label: "Protocollo" },
  { id: "paura-zero", label: "Paura zero" },
  { id: "dottore", label: "Chi sono" },
  { id: "team", label: "Team" },
  { id: "faq", label: "FAQ" },
];

export const TEAM = [
  {
    id: "chiara",
    name: "Dott.ssa Chiara",
    role: "Percorsi parodontali",
    photo: "/team/chiara.webp",
    text: "Ti accoglie con calma e ti accompagna passo dopo passo in ogni fase del percorso, dalla prima visita al mantenimento.",
  },
  {
    id: "erika",
    name: "Dott.ssa Erika",
    role: "Percorsi parodontali",
    photo: "/team/erika.webp",
    text: "Si prende cura di te durante le sedute e i controlli, con attenzione ai dettagli e un sorriso che mette subito a proprio agio.",
  },
];

export const SYMPTOMS = [
  "Gengive che sanguinano",
  "Alito cattivo",
  "Denti che si muovono",
  "Gengive gonfie o arrossate",
  "Gengive che si ritirano",
  "Sensibilità al freddo",
  "Pus o piccoli ascessi",
  "Spazi tra i denti che aumentano",
];

export const MARQUEE_ITEMS = [
  "Denti naturali, conservati",
  "Laser 450 · 635 · 808 nm",
  "Nessun bisturi",
  "Microscopio operatorio",
  "Paura zero",
  "Full Mouth Disinfection",
  "Gengive che smettono di sanguinare",
];

export const PROTOCOL = [
  {
    n: "01", title: "Ascolto e diagnosi", time: "Prima visita",
    text: "Un colloquio senza fretta, poi sondaggio parodontale, radiografie digitali e, quando indicato, test microbiologici e genetici per mappare i batteri responsabili e la tua risposta immunitaria.",
  },
  {
    n: "02", title: "Disinfezione laser-assistita", time: "Anche in un'unica seduta · ~3 ore",
    text: "Full Mouth Disinfection: il tartaro sotto gengiva viene rimosso con precisione al microscopio operatorio, poi il laser a tre lunghezze d'onda decontamina in profondità le tasche parodontali. Tutta la bocca, in modo integrale.",
  },
  {
    n: "03", title: "Primo controllo", time: "Dopo 10–15 giorni",
    text: "Verifichiamo come stanno guarendo i tessuti, rimuoviamo la placca residua e ti affidiamo istruzioni di igiene domiciliare cucite su di te.",
  },
  {
    n: "04", title: "Rivalutazione oggettiva", time: "A 2 mesi",
    text: "Nuovo sondaggio parodontale per misurare la guarigione con dati reali, non con impressioni. Se serve, ripetiamo le analisi batteriche.",
  },
  {
    n: "05", title: "Mantenimento su misura", time: "3–4 volte l'anno",
    text: "Richiami personalizzati in base al tuo profilo di rischio, con consigli anche su alimentazione e stile di vita, per mantenere nel tempo i risultati ottenuti.",
  },
];

export const FAQS = [
  {
    q: "La terapia laser fa male?",
    a: "Il trattamento è non chirurgico e minimamente invasivo: niente bisturi e niente punti. Quando serve si utilizza un'anestesia locale delicata e, dopo la seduta, i fastidi sono in genere lievi e facilmente gestibili.",
  },
  {
    q: "Il laser toglie il tartaro?",
    a: "No, ed è importante saperlo. Il tartaro sotto gengiva si rimuove meccanicamente con la massima precisione grazie al microscopio operatorio. Il laser ha un altro compito: decontaminare in profondità le tasche parodontali, ridurre l'infiammazione e favorire la guarigione.",
  },
  {
    q: "È possibile fare tutto in una sola seduta?",
    a: "Sì, previa valutazione di idoneità. La fase terapeutica principale può essere svolta in un'unica seduta di circa 3 ore, a cui seguono i controlli a 10–15 giorni e la rivalutazione a 2 mesi. È una soluzione ideale anche per chi arriva da lontano.",
  },
  {
    q: "I denti che si muovono si possono salvare?",
    a: "In molti casi sì. Eliminando l'infezione alla radice, i tessuti possono stabilizzarsi e, in presenza di difetti ossei verticali, si può osservare anche una rigenerazione ossea. Ogni situazione va valutata con una visita accurata.",
  },
  {
    q: "La parodontite è contagiosa?",
    a: "I batteri che la causano possono essere trasmessi attraverso la saliva. Per questo, in alcuni casi, è consigliabile un controllo anche per il partner o i familiari conviventi.",
  },
  {
    q: "Quanto costa il trattamento?",
    a: "Il costo dipende dalla complessità del caso e viene definito dopo la prima visita, con un preventivo chiaro. Salvare un dente naturale è quasi sempre più conveniente, sia biologicamente che economicamente, rispetto alla sua sostituzione con un impianto.",
  },
  {
    q: "Ho molta paura del dentista: cosa posso fare?",
    a: "Parlarne è già il primo passo. Il primo incontro può essere solo una conversazione, senza strumenti. Concordiamo un segnale per fermarci quando vuoi e, su indicazione, è possibile valutare la sedazione cosciente con protossido d'azoto presso il Centro.",
  },
];

export const WAVELENGTHS = [
  {
    nm: 450,
    light: "Luce blu",
    glow: "#7FA7E0",
    title: "Precisione sui tessuti molli",
    text: "Molto assorbita da emoglobina e pigmenti: lavora con estrema delicatezza sulla gengiva infiammata, favorisce la coagulazione e riduce il sanguinamento con un minimo riscaldamento dei tessuti.",
  },
  {
    nm: 635,
    light: "Luce rossa",
    glow: "#E58C7E",
    title: "Biostimolazione e terapia fotodinamica",
    text: "Attiva il fotosensibilizzante nella terapia fotodinamica antibatterica e stimola le cellule: aiuta a sgonfiare le gengive, calmare il dolore e accelerare la guarigione.",
  },
  {
    nm: 808,
    light: "Vicino infrarosso",
    glow: "#C98FB8",
    title: "Decontaminazione in profondità",
    text: "Penetra in profondità nelle tasche parodontali: riduce la carica batterica dove gli strumenti non arrivano e ha un effetto analgesico e antinfiammatorio.",
  },
];
